import {
  ActionsUnion,
  IActiveTripResponseV2,
  IStationUserActiveTripResponseV2,
  ITripFilters,
  IStationUserTripFilters
} from 'src/types'
import { createAction } from '../helpers'
import * as constants from '../../constants'
import { stationUserTrips } from '../../../services/station-user-trips'
export type IStationUserTripsAction = ActionsUnion<typeof actionCreators>
;(window as any).stationUserTrips = stationUserTrips

export const actionCreators = {
  getManyTripsRequest: () => createAction(constants.STATION_USER_TRIPS_FETCH_REQUEST),
  getManyTripsSuccess: (trips: IStationUserActiveTripResponseV2[]) =>
    createAction(constants.STATION_USER_TRIPS_FETCH_SUCCESS, trips),
  getManyTripsFailure: (error: string) => createAction(constants.TRIPS_FETCH_FAILURE, error)
}

export function getManyTrips(params: IStationUserTripFilters, currentUserId: string) {
  const { getManyTripsRequest, getManyTripsSuccess, getManyTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getManyTripsRequest())

    return stationUserTrips.fetch(params.orgId, currentUserId).then(
      (resp: any) => {
        dispatch(getManyTripsSuccess(resp.trips && resp.trips.items))
        return resp
      },
      (res: any) => {
        dispatch(getManyTripsFailure(res.data))
        setTimeout(() => {
          dispatch(getManyTripsFailure(''))
        }, 5000)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/station-user-trips/index.ts